import React from 'react';

/**
 * Envelope animado de "falta 1 passo": mesmo desenho do AnimatedCheck (mesmo tamanho,
 * mesmo pop, mesmo anel percorrendo a borda), só que em âmbar e com a aba do envelope
 * sendo desenhada no lugar do traço do check. Usado quando a tela anuncia PENDÊNCIA em
 * vez de conclusão, como depois do cadastro, enquanto o e-mail não foi confirmado.
 *
 * Respeita prefers-reduced-motion: sem animação, mostrando direto o estado final.
 * `className` extra vai no wrapper (ex.: espaçamento específico da tela).
 */
export default function AnimatedMail({ className = '' }) {
  return (
    <div className={`mx-auto mb-4 ${className}`}>
      <style>{`
        @keyframes wa-mail-pop { 0%{transform:scale(0.5);opacity:0;} 60%{transform:scale(1.08);opacity:1;} 100%{transform:scale(1);} }
        @keyframes wa-mail-draw { to { stroke-dashoffset: 0; } }
        @keyframes wa-mail-ring { to { stroke-dashoffset: 0; } }
        .wa-mail-pop { animation: wa-mail-pop 0.7s cubic-bezier(0.22, 1, 0.36, 1) both; }
        .wa-mail-draw { stroke-dasharray: 30; stroke-dashoffset: 30; animation: wa-mail-draw 0.7s ease-out 0.45s forwards; }
        .wa-mail-ring { stroke-dasharray: 239; stroke-dashoffset: 239; animation: wa-mail-ring 0.9s ease-out 1.05s forwards; }
        @media (prefers-reduced-motion: reduce) {
          .wa-mail-pop { animation: none; }
          .wa-mail-draw { animation: none; stroke-dashoffset: 0; }
          .wa-mail-ring { animation: none; stroke-dashoffset: 0; }
        }
      `}</style>
      <div className="wa-mail-pop relative w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
        <svg className="absolute inset-0 w-full h-full -rotate-90 text-amber-600" viewBox="0 0 80 80" fill="none" aria-hidden="true">
          <circle className="wa-mail-ring" cx="40" cy="40" r="38" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
        </svg>
        <svg className="w-10 h-10 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path className="wa-mail-draw" d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
      </div>
    </div>
  );
}
